<template>
  <div>


    <!--    <a role="button" class="btn btn-primary" @click="submit()"><i class="fas fa-save"></i></a>-->
    <!--    <a class="btn btn-primary" @click="DataItem_AddLast"><i class="fas fa-plus-circle"></i></a>-->
    <a role="button" class="btn btn-primary" @click="NewItem()">新增</a>

    <!--    查詢訂單-->
    <!--    <a role="button" class="btn btn-primary" @click="QueryStatus('payed')">已付款</a>-->
    <!--    <a role="button" class="btn btn-primary" @click="QueryStatus('finish')">已完成</a>-->
    <!--    <a role="button" class="btn btn-primary" @click="QueryStatus('cancel')">已取消</a>-->

    <!--    匯出-->
    <!--    <a role="button" class="btn btn-info" onclick="ExportToExcel()">匯出Excel</a>-->

    <table class="table table-hover" id="tblMain">
      <thead class="thead-light">
      <tr>
        <th>功能</th>
        <th>主題</th>
        <th>日期</th>
        <th>內容</th>
        <th>人數上限</th>
        <th>已報名人數</th>
        <th>是否啟用</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(item,index) in this.datas" :key="index">
        <td width="200px">
          <a role="button" class="btn btn-primary" href="#" @click="gotoDetail(item.id)">編輯</a>
          <a role="button" class="btn btn-danger" href="#" @click="deleteDetail(item.id)">刪除</a>
          <!--          <span v-if="item.status==='expired'">-->
          <!--            <a role="button" class="btn btn-danger" href="#" @click="deleteDetail(item.id)">刪除</a>-->
          <!--          </span>-->

<!--          <a class="btn btn-primary" @click="DataItem_MoveUp(item)"><i class="fa fa-angle-up"></i>  </a>-->
<!--          <a class="btn btn-primary" @click="DataItem_MoveDown(item)"><i class="fa fa-angle-down"></i>  </a>-->

        </td>
        <td width="200px">
          {{item.name}}
        </td>
        <td width="200px">
          {{item.eventDt}}
        </td>
        <td width="220px">
          <span v-html="item.eventContent"></span>
        </td>
        <td width="120px">
          <span v-if="item.applicant_limit_type===0">不限</span>
          <span v-else>{{item.applicant_limit}}人</span>
        </td>
        <td width="120px">
          <span >{{item.applicant_current}}人</span>
          <a role="button" class="btn btn-primary" href="#" @click="queryApplicant(item.id)"> 名單</a>
        </td>
        <td width="150px">
          <div v-if="item.status===0">
            <span >啟用中</span>
            <a role="button" class="btn btn-danger" href="#" @click="changeStatus(item.id,1)">停用</a>
          </div>
          <div v-else>
            <span >停用中</span>
            <a role="button" class="btn btn-primary" href="#" @click="changeStatus(item.id,0)">啟用</a>
          </div>

        </td>
      </tr>

      </tbody>
    </table>

  </div>
</template>

<script>
/**

 **/


import Vue from "vue";
import apiFireGodsec from "@/views/fireGods/js/apiFireGodsec";

export default {
  components: {},
  //name: "setting",
  // props: [""],
  data: function () {
    return {
      id: "",
      dataReady: false,
      formData: {
        name: "",
      },
      datas:{

      },
      queryStatus:"payed",
    };
  },
  methods: {
    NewItem(){
      this.$router.push({ name: 'EventDefine2Detail', query: { id: '' }})
    },
    Export(){

    },
    QueryStatus(status){
      this.queryStatus=status;
      this.loadData();
    },
    loadData() {
      // let data=apiAdmin.api_getContent(this.queryType);
      // debugger // eslint-disable-line
      // console.log(data);
      let that=this;

      apiFireGodsec.api_Admin_EventDefine2_Query().then((data)=>{
        let dataApi=data.data.data;
        // let dataApi=apiAdmin.init(data.data.data);
        that.datas=dataApi;
      })
    },
    // submit(){
    //   debugger // eslint-disable-line
    //   apiFireGodsec.api_Admin_EventDefine_Save(this.datas).then((data)=>{
    //     console.log(data);
    //     alert('儲存成功')
    //   })
    // },
    convertToRealUrl(url){
      return Vue.prototype.$apiAdress.replace(/\/$/, "") +url;
    },
    gotoDetail(id){
      this.$router.push({ name: 'EventDefine2Detail', query: { id: id }})
    },
    deleteDetail(id){
      //confirm delete
      if(confirm('確定要刪除嗎?')){
        apiFireGodsec.api_Admin_EventDefine2_Del(id).then(()=>{
          alert('刪除成功')
          this.loadData();
        })
      }

    },
    changeStatus(id){
      apiFireGodsec.api_Admin_EventDefine2_Disable(id).then((data)=>{
        console.log(data);
        alert('儲存成功')
        this.loadData();
      })
    },
    queryApplicant(id){
      this.$router.push({ name: 'EventDefine2Applicant', query: { id: id }})
    },
    // DataItem_MoveUp(item){
    //   arrayUtil.orderMove(false,item.id,this.datas,"id","sortOrder")
    // },
    // DataItem_MoveDown(item){
    //   arrayUtil.orderMove(true,item.id,this.datas,"id","sortOrder")
    // },
  },
  mounted() {
    this.loadData()
  },
}
</script>

<style scoped>
#tblMain{
  width: 1200px;
}
.btn{
  color: white !important;
  margin: 5px;
  /*width: 40px;*/
}
</style>
